<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label">{{ $t('disciplinaryActivity.nameKH') }}
        </label>
        <input ref="dis_activity_kh" v-model="model.dis_activity_kh" type="text" class="form-control kh-font"
          :class="{ 'is-invalid': errors.has('dis_activity_kh') }"
          :placeholder="$t('disciplinaryActivity.enternameKh')" />
        <div class="invalid-feedback" v-if="errors.has('dis_activity_kh')">
          {{ errors.first('dis_activity_kh') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label required">{{ $t('disciplinaryActivity.nameEn') }}
        </label>
        <input v-model="model.dis_activity_en" type="text" class="form-control"
          :class="{ 'is-invalid': errors.has('dis_activity_en') }"
          :placeholder="$t('disciplinaryActivity.enternameEn')" />
        <div class="invalid-feedback" v-if="errors.has('dis_activity_en')">
          {{ errors.first('dis_activity_en') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('disciplinaryActivity.letterType') }}
        </label>
        <select class="form-control" v-model="model.letter_type">
          <option value="">{{ $t('select') }}</option>
          <option value="Warning">Warning</option>
          <option value="Dismiss">Dismiss</option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('letter_type')">
          {{ errors.first('letter_type') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{ $t('disciplinaryActivity.penaltyType') }}
        </label>
        <select class="form-control" v-model="model.penalty_type_id">
          <option v-for="(pen, index) in penalties" :value="pen.penalty_type_id">{{ pen.penalty_type_en }}</option>
        </select>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button class="ml-2" color="primary" :disabled="saving" :waiting="saving" @click="update"
          v-if="editing == true">
          {{ $t('update') }}
        </ts-button>
        <ts-button class="ml-2" color="primary" :disabled="saving" :waiting="saving" @click="save" v-else>
          {{ $t('save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  name: 'activity-create-form',
  props: ['edit'],
  data() {
    return {
      model: {
        dis_activity_kh: '',
        dis_activity_en: '',
        letter_type: '',
        penalty_type_id: ''
      },
      penalties: [],
      errors: new Errors(),
      saving: false,
      editing: false
    }
  },
  mounted() {
    this.$refs.dis_activity_kh.focus()
  },
  async created() {
    this.setEdit()
    this.fetchPenalty()
  },
  methods: {
    ...mapActions('disciplinaryActivity', ['getPenalty']),
    cancel() {
      this.editing = false
      this.clearForm()
      // this.$emit('cancel')
      this.$router.push({ name: 'disciplinary-activity' })
    },

    fetchPenalty() {
      this.getPenalty()
        .then(response => {
          this.penalties = response.data
        })
    },

    async save() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'disciplinaryActivity/create',
          this.model
        )
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
        this.$refs.dis_activity_kh.focus()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'disciplinaryActivity/update',
          this.model
        )

        this.$toasted.success(response.message)
        this.$router.push({ name: 'disciplinary-activity' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
        this.$refs.dis_activity_kh.focus()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit() {
      if (this.edit === null || this.edit === undefined) return
      this.errors = new Errors()
      this.model = Object.assign({}, this.edit)
      this.editing = true
    },

    clearForm() {
      this.model.dis_activity_kh = ''
      this.model.dis_activity_en = ''
      this.model.letter_type = ''
      this.model.penalty_type_id = ''
    }
  },
  watch: {
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
